export default "__VITE_ASSET__C7tCWYdy__"